<template>
  <section class="categories-section">
    <div class="flex section-actions">
      <BaseButton @click="updateCategories">עדכון הקטגוריות</BaseButton>
    </div>

    <div class="categoreis gap-20" ref="categoriesList">
      <div
        tag="a"
        v-for="(category) in getCategories"
        :key="category.familycode"
        class="category"
        :class="{ disabled: !category.isShownInModal }"
      >
        {{ category.familyname }}
        <form
          class="category-actions"
          :class="{ disabled: !category.isShownInModal }"
        >
          <div class="flex gap-10">
            <label :for="`priority-category-${category.familycode}`"
              >סדר תצוגה:
            </label>
            <input
              :value="category.sortOrderNumber"
              :id="`priority-category-${category.familycode}`"
              type="text"
              inputmode="numeric"
              @input="updateSortOrderCategory(category.familycode, $event)"
              :disabled="isProtected(category.familycode)"
              required
            />
          </div>
          <div class="flex gap-10">
            <label :for="`expand-category-${category.familycode}`"
              >הרחב את גודל הכפתור?
            </label>
            <input
              :checked="category.isButtonExpand"
              :id="`expand-category-${category.familycode}`"
              type="checkbox"
              @click="updateExpandCategory(category.familycode)"
              :disabled="isProtected(category.familycode)"
            />
          </div>
          <div class="flex gap-10">
            <label :for="`show-category-${category.familycode}`"
              >הצג קטגוריה?
            </label>
            <input
              :checked="category.isShownInModal"
              :id="`show-category-${category.familycode}`"
              type="checkbox"
              @click="updateShowCategory(category.familycode)"
              :disabled="isProtected(category.familycode)"
            />
          </div>
        </form>
      </div>
    </div>

    <div class="flex section-actions">
      <BaseButton @click="updateSubCategoriesList">עדכון תתי הקטגוריות</BaseButton>
    </div>

    <div
      v-for="group in subCategoriesGrouped"
      :key="group.familycode"
      class="subcategory-group"
    >
      <h4 class="subcategory-group-title">{{ group.familyname }}</h4>
      <div class="subcategory-grid gap-20">
        <div
          v-for="subCategory in group.subCategories"
          :key="subCategory.id"
          class="category"
        >
          {{ subCategory.name }}
          <form class="category-actions">
            <div class="flex gap-10">
              <label :for="`priority-subcategory-${subCategory.id}`"
                >סדר תצוגה:
              </label>
              <input
                :value="subCategory.sortOrderNumber"
                :id="`priority-subcategory-${subCategory.id}`"
                type="text"
                inputmode="numeric"
                @input="updateSortOrderSubCategory(subCategory.id, $event)"
                required
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import BaseButton from "../helpers/BaseButton.vue";

export default {
  components: { BaseButton },
  data() {
    return {
      categories: [],
      subCategoriesList: [],
    };
  },
  mounted() {
    this.loadCategories();
    this.loadSubCategories();
  },
  methods: {
    findFamilyIndex(familyCode) {
      return this.categories.findIndex(
        (category) => category.familycode === familyCode
      );
    },
    isProtected(familyCode) {
      return familyCode === "-2";
    },
    updateShowCategory(familyCode) {
      const index = this.findFamilyIndex(familyCode);
      this.categories[index].isShownInModal =
        !this.categories[index].isShownInModal;
    },
    updateSortOrderCategory(familyCode, event) {
      const index = this.findFamilyIndex(familyCode);
      if (!isNaN(parseInt(event.target.value)))
        this.categories[index].sortOrderNumber = parseInt(event.target.value);
    },
    updateExpandCategory(familyCode) {
      const index = this.findFamilyIndex(familyCode);
      this.categories[index].isButtonExpand =
        !this.categories[index].isButtonExpand;
    },
    loadCategories() {
      this.categories = this.getCategories;
      console.log(this.categories);
    },
    async updateCategories() {
      try {
        await this.$store.dispatch("Parts/updateFamilies", this.categories);
      } catch (error) {
        console.log(error);
      }
    },
    findSubCategoryIndex(id) {
      return this.subCategoriesList.findIndex(
        (subCategory) => subCategory.id === id
      );
    },
    updateSortOrderSubCategory(id, event) {
      const index = this.findSubCategoryIndex(id);
      if (!isNaN(parseInt(event.target.value)))
        this.subCategoriesList[index].sortOrderNumber = parseInt(
          event.target.value
        );
    },
    getFamilyName(familyCode) {
      const family = this.getCategories.find(
        (category) => category.familycode === familyCode
      );
      return family ? family.familyname : familyCode;
    },
    loadSubCategories() {
      this.subCategoriesList = this.getSubCategoriesFromStore
        .slice()
        .sort((a, b) => {
          const familyNameA = this.getFamilyName(a.familycode);
          const familyNameB = this.getFamilyName(b.familycode);
          if (familyNameA !== familyNameB)
            return familyNameA.localeCompare(familyNameB, "he");
          return a.sortOrderNumber - b.sortOrderNumber;
        });
    },
    async updateSubCategoriesList() {
      try {
        const success = await this.$store.dispatch(
          "Parts/updateSubCategories",
          this.subCategoriesList
        );
        if (success) this.loadSubCategories();
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    subCategoriesGrouped() {
      const groups = {};
      this.subCategoriesList.forEach((subCategory) => {
        if (!groups[subCategory.familycode]) {
          groups[subCategory.familycode] = {
            familycode: subCategory.familycode,
            familyname: this.getFamilyName(subCategory.familycode),
            subCategories: [],
          };
        }
        groups[subCategory.familycode].subCategories.push(subCategory);
      });
      return Object.values(groups).sort((a, b) =>
        a.familyname.localeCompare(b.familyname, "he")
      );
    },
    ...mapGetters({
      getCategories: "Parts/getFamilies",
      getSubCategoriesFromStore: "Parts/getSubCategories",
    }),
  },
};
</script>

<style scoped lang="scss">
.section-actions {
  justify-content: space-between;
  margin-bottom: 20px;
}

.category-actions label {
  color: white;
  font-size: $largTextSize;
}

.category-actions.disabled {
  label {
    color: rgb(217, 217, 217);
  }
}

.category-actions {
  display: flex;
  text-shadow: none;
  box-shadow: none;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;

  input[id*="priority-category"] {
    width: 30px;
    text-align: center;
    color: white;
  }

  input[id*="expand-category"],
  input[id*="show-category"] {
    width: 20px;
    opacity: 1;
    position: static;
    pointer-events: fill;
    border-bottom: none;
    box-shadow: none;
  }
}
.categories-section {
  padding: 10px;
}

.subcategory-group {
  margin-bottom: 30px;
}

.subcategory-group-title {
  color: $primaryTextColor;
  font-family: "felix007", sans-serif;
  font-size: $largTextSize;
  padding: 6px 14px;
  margin-bottom: 15px;
  background: linear-gradient(
    60deg,
    rgba(0, 0, 0, 0) 30%,
    #601b0f 97%
  );
  border-radius: 10px;
}

.subcategory-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 20px;
  color: white;
  padding: 0 20px;
}

@media (min-width: 900px) {
  .subcategory-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
.categoreis {
  display: grid !important;
  grid-template-columns: repeat(1, 1fr);
  gap: 20px !important;
  color: white;
  overflow: scroll;
  overflow-x: hidden;
  height: calc(90vh - 90px);
  padding: 20px;
}

@media (min-width: 900px) {
  .categoreis {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 50px;
  }
}

.category.disabled {
  color: #e0e0e0;
}
.category {
  margin-bottom: 10px;
  font-family: "felix007", sans-serif;
  text-align: center;
  font-size: $largestTextSize !important;
  letter-spacing: 1px;
  padding: 10px;
  text-shadow: 0px 3px 4px black;
  box-shadow: 1px 1px 1px #ffe6ad;
  background-color: $secondaryTextColor;
  border-radius: 20px;
  color: #ffe6ad;
}
.distlines-select {
  height: calc(80vh - 180px);
  margin-top: 20px;
  overflow: scroll;
  overflow-x: hidden;
}

.new-distline {
  margin-top: 10px;
}
.text-continer {
  margin-bottom: 10px;
  color: white;
}
.content {
  width: 100%;
  font-size: $mediumTextSize;
}
.icon {
  width: 30px;
}
.add-alert {
  width: 90%;
}
.distlines {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px;
  max-width: 700px;
}
.alert {
  width: 100%;
  padding: 10px;
  box-shadow: 1px 1px 1px #ffe6ad;
  border-radius: 20px;
  background: #393945;
}

.product-continer {
  margin-bottom: 10px;
}
button {
  margin-left: 10px;
}
.type {
  color: white;
}
</style>
